import { css } from '@emotion/react';

export const useStyles = (props) => ({
    blueLink: css({
        textDecoration: "none !important",
        "& p": {
            color: "#00a7dd !important",
            textAlign: "center",
            textTransform: "capitalize",
            fontSize: "14px"
        }
    }),
    rightIcon: css({
        color: "#00a7dd !important",
        fontSize: "18px !important",
        width: "18px !important",
        height: "18px !important",
        marginLeft: "5px",
        position: "relative",
        top: "2px"
    }),
});
